import { LaunchpadTable } from '../../mui-overrides/LaunchpadTable';
import { TableCell, TableRow } from '@mui/material';
import { EmptyTable } from '../../utils/EmtpyTable';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePreorders } from '../../../hooks/usePreorders';
import { TPreorder } from '../../../models';
import { format } from 'date-fns';

const initialPage = 0;
const initialRowsPerPage = 25;

interface Props {
  assetId: string;
}

export const PreordersTable: FC<Props> = ({ assetId }) => {
  const { t } = useTranslation();
  const [page, setPage] = useState(initialPage);
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);
  const preorders: { items: TPreorder[]; count: number } = usePreorders(assetId, { page, rowsPerPage }, t);

  return (
    <LaunchpadTable
      hidePagination={false}
      page={page}
      rowsPerPage={rowsPerPage}
      setPage={setPage}
      setRowsPerPage={(rowsPerPage) => {
        setPage(initialPage);
        setRowsPerPage(rowsPerPage);
      }}
      length={preorders.count}
      renderHeader={() => (
        <TableRow>
          <TableCell>{t('preorders.overview.table.userId')}</TableCell>
          <TableCell>{t('preorders.overview.table.date')}</TableCell>
          <TableCell>{t('preorders.overview.table.amount')}</TableCell>
          <TableCell></TableCell>
        </TableRow>
      )}
      renderRows={() => {
        if (preorders.items.length === 0) {
          return <EmptyTable bottomText={t('general.errors.noItemsFound')} />;
        }
        return (
          <>
            {preorders.items.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row.userId}</TableCell>
                <TableCell>{format(new Date(row.date), 'dd/MM/yyyy')}</TableCell>
                <TableCell>{row.amount}</TableCell>
              </TableRow>
            ))}
          </>
        );
      }}
    />
  );
};
